import { ReactNode } from 'react';
import { Breadcrumbs, BreadcrumbItem } from './Breadcrumbs';

interface PageHeaderProps {
  title: string;
  /** Plain text, or a real React node (e.g. a StatusBadge) for pages whose description line includes more than plain text. */
  description?: ReactNode;
  actions?: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

/**
 * The real page-header pattern already repeated inline across 60+
 * pages (title + optional description + arbitrary actions),
 * extracted into one component so it's genuinely consistent rather
 * than each page's own slightly-different markup. Breadcrumbs are
 * optional - many pages (simple top-level lists) don't need them,
 * matching the brief's "consistency without rigidity."
 */
export function PageHeader({ title, description, actions, breadcrumbs }: PageHeaderProps) {
  return (
    <>
      {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
      <div className="page-header">
        <h1>{title}</h1>
        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
      {description && <p className="page-header-description">{description}</p>}
    </>
  );
}
